import { Link } from "@heroui/react";
import { Shield } from "lucide-react";

import { InfoSection } from "./components/InfoSection";

export const InfoPrivacy = () => {
  return (
    <InfoSection icon={Shield} title="Privacy">
      <ul className="list-disc text-default-800 ml-10 flex flex-col gap-1">
        <li>
          <Link href="https://www.npmjs.com/package/altcha-lib" target="_blank">
            altcha-lib
          </Link>{" "}
          is used for proof-of-work captcha verification
        </li>
        <li>Usernames should not be assumed to be private</li>
      </ul>
    </InfoSection>
  );
};
